import me from "./me.jpeg";
import me2 from "./me2.jpeg";

import BtcMinerThumbnail from "./BTCminer/BtcMinerThumbnail.png";
import StartScreen from "./BTCminer/Startscreen.png";
import FirstItem from "./BTCminer/FirstItem.png";
import BonusShop from "./BTCminer/BonusShop.png";
import EndGame from "./BTCminer/endgame.png";
import GoldenCoin from "./BTCminer/GoldenCoin.png";
import Quests from "./BTCminer/Quests.png";
import Stats from "./BTCminer/stats.png";

import BudgeThumbnail from "./Budge/BudgeThumbnail.png";
import LoginPage from "./Budge/LoginPage.png";
import RegisterPage from "./Budge/RegisterPage.png";
import OverviewPage from "./Budge/OverviewPage.png";
import AddTransaction from "./Budge/AddTransaction.png";
import SingleTransaction from "./Budge/SingleTransaction.png";
import FilterPage from "./Budge/FilterPage.png";

import PortfolioThumbnail from "./PortfolioWebsite/Portfolio_thumbnail.png";
import LandingPage from "./PortfolioWebsite/LandingPage.png";
import Vaardigheden from "./PortfolioWebsite/Vaardigheden.png";
import LeukeWeetjes from "./PortfolioWebsite/LeukeWeetjes.png";

import FuturismaLogo from "./Futurisma/FuturismaLogo.png";
import FuturismaLanding from "./Futurisma/FuturismaLanding.png";
import FuturismaProducts from "./Futurisma/FuturismaProducts.png";
import FuturismaCabins from "./Futurisma/FuturismaCabins.png";
import FuturismaSingleProduct from "./Futurisma/FuturismaSingleProduct.png";
import FuturismaContact from "./Futurisma/FuturismaContact.png";
import FuturismaWPF from "./Futurisma/FuturismaWPF.png";
import FuturismaDatabase from "./Futurisma/FuturismaDatabase.png";

import KeysMaken from "./EncryptionTool/KeysMaken.png";
import FotoEncrypteer from "./EncryptionTool/FotoEncrypteer.png";
import FotoDecrypteer from "./EncryptionTool/FotoDecrypteer.png";
import RSA from "./EncryptionTool/RSA.png";
import encryption from "./EncryptionTool/encryption.png";

import homepage from "./WeightLogger/homepage.png";

import ScoprThumbnail from "./Scopr/dashboard.png";
import StartPagina from "./Scopr/StartPagina.png";
import ProjectenOverzicht from "./Scopr/ProjectenOverzicht.png";
import Project1 from "./Scopr/Project1.png";
import Project2 from "./Scopr/Project2.png";
import Project3 from "./Scopr/Project3.png";
import Users from "./Scopr/Users.png";
import api from "./Scopr/api.png";

const Images = {
    Personal: {
        headshot: {
            src: me,
            description: ""
        },
        headshot2: {
            src: me2,
            description: ""
        }
    },
    BtcMiner: {
        BtcMinerThumbnail: {
            src: BtcMinerThumbnail,
            description: "Bitcoin Miner thumbnail",
        },
        StartScreen: {
            src: StartScreen,
            description: "This is the screen you see when you start the game. There's not much to see or to do except for clicking that giant Bitcoin.",
        },
        FirstItem: {
            src: FirstItem,
            description: "Once you have clicked 15 times, the shop opens up and you can see your first item that you can buy. This item will provide passive BTC income.",
        },
        BonusShop: {
            src: BonusShop,
            description: "The items that you can buy in the regular shop also can be upgraded in the bonus shop. This will improve the already-bought items and future items.",
        },
        EndGame: {
            src: EndGame,
            description: "This is what the game will look like when you've played quite a bit. You can also see the mini coins falling in the background, this is based on the passive income.",
        },
        GoldenCoin: {
            src: GoldenCoin,
            description: "Very rarely, there will spawn a falling Golden Coin. If you're able to click it, you'll gain a large amount of BTC depending on your current income. Be fast though, it falls FAST!",
        },
        Quests: {
            src: Quests,
            description: "While playing the game you can unlock certain quests, can you unlock all 25 quests?",
        },
        Stats: {
            src: Stats,
            description: "An overview of all kind of stats.",
        },
    },
    Budge: {
        BudgeThumbnail: {
            src: BudgeThumbnail,
            description: "Budge app logo",
        },
        LoginPage: {
            src: LoginPage,
            description: "login page",
        },
        RegisterPage: {
            src: RegisterPage,
            description: "Register page",
        },
        OverviewPage: {
            src: OverviewPage,
            description: "At the top it has several buttons for quick-filtering on today, this week or last month. Below that there's a table which shows your spending based on the category their in. Below you see can an overview of all your transactions.",
        },
        AddTransaction: {
            src: AddTransaction,
            description: "Adding a transaction",
        },
        SingleTransaction: {
            src: SingleTransaction,
            description: "Detailpage of a single transaction. Here you could also edit or delete the current transaction.",
        },
        FilterPage: {
            src: FilterPage,
            description: "Filter through your transactions based on name, amount, dates or category.",
        },
    },
    Portfolio: {
        PortfolioThumbnail: {
            src: PortfolioThumbnail,
            description: "Portfolio website project showcasing design skills.",
        },
        LandingPage: {
            src: LandingPage,
            description: "Landingspagina",
        },
        Vaardigheden: {
            src: Vaardigheden,
            description: "screenshot 1 ",
        },
        LeukeWeetjes: {
            src: LeukeWeetjes,
            description: "Screenshot 2",
        },
    },
    Futurisma: {
        FuturismaLanding: {
            src: FuturismaLanding,
            description: "Screenshot 2",
        },
        FuturismaProducts: {
            src: FuturismaProducts,
            description: "Screenshot 2",
        },
        FuturismaCabins: {
            src: FuturismaCabins,
            description: "Screenshot 2",
        },
        FuturismaSingleProduct: {
            src: FuturismaSingleProduct,
            description: "Screenshot 2",
        },
        FuturismaContact: {
            src: FuturismaContact,
            description: "Screenshot 2",
        },
        FuturismaWPF: {
            src: FuturismaWPF,
            description: "Screenshot 2",
        },
        FuturismaDatabase: {
            src: FuturismaDatabase,
            description: "Screenshot 2",
        },
        FuturismaLogo: {
            src: FuturismaLogo,
            description: "Screenshot 2",
        },
    },
    Encryption:{
        Encryption: {
            src: encryption,
            description: "Here you can create secret keys."
        },
        KeysMaken: {
            src: KeysMaken,
            description: "Here you can create secret keys."
        },
        FotoEncrypteer: {
            src: FotoEncrypteer,
            description: "Use the secret keys to encrypt an image."
        },
        FotoDecrypteer: {
            src: FotoDecrypteer,
            description: "Decrypt the ciphertext back to an image."
        },
        RSA: {
            src: RSA,
            description: "encrypting keys using paired keys (RSA)."
        }

    },
    WeightLogger:{
        homepage: {
            src: homepage,
            description: "homepage"
        }
    },
    Scopr: {
        Thumbnail: {
            src: ScoprThumbnail,
            description: "The landing page of the dashboard. The amount of projects per day/week/month are shown and are clickable to open those projects. There's also a graph showing from what province the project originate. "
        },
        StartPagina: {
            src: StartPagina,
            description: "The landing page of the dashboard. The amount of projects per day/week/month are shown and are clickable to open those projects. There's also a graph showing from what province the project originate. "
        },
        ProjectenOverzicht: {
            src: ProjectenOverzicht,
            description: "Here the projects will open based on day/week/month"
        },
        Project1: {
            src: Project1,
            description: "On the single project page you can find all sorts of information about the project. For demonstration purposes, it's a fictional project."
        },
        Project2: {
            src: Project2,
            description: "More information about the project such as conformity of the house or the amount of rooms."
        },
        Project3: {
            src: Project3,
            description: "At last it shows the pictures provided by the user and also a button to download the full PDF version of the project."
        },
        Users: {
            src: Users,
            description: "Users can be searched by name, email or phonenumber. Once the user is clicked, their projects will open at the top of the page."
        },
        api: {
            src: api,
            description: "API"
        },



    }
};

export default Images;
